import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dialogId: null,
  dialogName: '',
  messages: [],
  dialogs: [],
  ratingMessageId: null,
  isAwaitingRole: false,
  selectedSubOption: 'quick',
  input: '',
  mode: 'dialogs',
  isWaiting: false,
  isWebSearch: false,
  isStorageUse: false,
  storageFiles: []
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setStorageFiles: (state, action) => {  // Добавлено
      state.storageFiles = action.payload;
    },
    setIsStorageUse: (state, action) => {
      state.isStorageUse = action.payload;
    },
    setIsWebSearch: (state, action) => {
      state.isWebSearch = action.payload;
    },
    setDialogName: (state, action) => {
      state.dialogName = action.payload;
    },
    setIsWaiting: (state, action) => {
      state.isWaiting = action.payload;
    },
    setDialogs: (state, action) => {
      state.dialogs = action.payload;
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setDialogId: (state, action) => {
      state.dialogId = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setSelectedSubOption: (state, action) => {
      state.selectedSubOption = action.payload;
    },    
    setRatingMessageId: (state, action) => {
      state.ratingMessageId = action.payload;
    },
    setIsAwaitingRole: (state, action) => {
      state.isAwaitingRole = action.payload;
    },
    setInput: (state, action) => {
      state.input = action.payload;
    }
  },
});

export const { setStorageFiles, setIsStorageUse, setIsWebSearch, setDialogName, setIsWaiting, setDialogId, setMessages, setRatingMessageId, setIsAwaitingRole, setSelectedSubOption, setInput, setMode, setDialogs } = chatSlice.actions;

export const selectDialogId = (state) => state.chat.dialogId;
export const selectMessages = (state) => state.chat.messages;
export const selectRatingMessageId = (state) => state.chat.ratingMessageId;
export const selectIsAwaitingRole = (state) => state.chat.isAwaitingRole;
export const selectSelectedSubOption = (state) => state.chat.selectedSubOption;
export const selectInput = (state) => state.chat.input;
export const selectMode = (state) => state.chat.mode;
export const selectDialogs = (state) => state.chat.dialogs;
export const selectIsWaiting = (state) => state.chat.isWaiting;
export const selectDialogName = (state) => state.chat.dialogName;
export const selectIsWebSearch = (state) => state.chat.isWebSearch;
export const selectIsStorageUse = (state) => state.chat.isStorageUse;
export const selectStorageFiles = (state) => state.chat.storageFiles;


export default chatSlice.reducer;
